import React from "react";
import { Cpu } from "lucide-react";

interface TechItem {
  id: number | string;
  name_of_technology: string;
  get_logo_url: string;
}

interface TechProps {
  techList: TechItem[];
  is_recent_job?: boolean;
}

function Technologies({ techList, is_recent_job }: TechProps) {
  if (!Array.isArray(techList) || techList.length === 0) {
    return null;
  }

  const sortedList = [...techList].sort((a, b) => Number(a.id) - Number(b.id));

  return (
    <section className="cht-py-14 sm:cht-py-20 cht-bg-white cht-border-y cht-border-slate-200/80">
      <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
        <header className="cht-text-center cht-max-w-2xl cht-mx-auto cht-mb-12 sm:cht-mb-16">
          <div className="cht-inline-flex cht-items-center cht-gap-2 cht-px-3.5 cht-py-1.5 cht-bg-blue-50 cht-border cht-border-blue-100 cht-rounded-full cht-text-xs !cht-font-bold cht-text-[#3e57da] cht-mb-4">
            <Cpu size={14} />
            <span>{is_recent_job ? "Stack Architecture" : "Engineering Ecosystem"}</span>
          </div>

          <h2 className="!cht-font-heading cht-text-2xl sm:cht-text-3xl md:cht-text-4xl !cht-font-extrabold cht-text-[#1e293b] cht-tracking-tight cht-mb-3">
            {is_recent_job ? "Technologies & Platforms Utilized" : "Technologies & Frameworks"}
          </h2>

          <p className="!cht-font-body cht-text-sm sm:cht-text-base cht-text-slate-600 cht-leading-relaxed">
            {is_recent_job
              ? "Modern programming languages, enterprise frameworks, and infrastructure tools applied in this delivery."
              : "Our engineering team leverages battle-tested frameworks, cloud infrastructure, and modern developer tooling."}
          </p>
        </header>

        <div className="cht-grid cht-grid-cols-2 sm:cht-grid-cols-3 md:cht-grid-cols-4 lg:cht-grid-cols-5 cht-gap-4 sm:cht-gap-5 cht-justify-center">
          {sortedList.map((item) => (
            <div
              key={item.id}
              className="cht-rounded-[20px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft cht-p-5 sm:cht-p-6 cht-flex cht-flex-col cht-items-center cht-justify-center cht-text-center cht-transition-all cht-duration-300 hover:cht-border-[#3e57da]/60 hover:cht-shadow-md hover:-cht-translate-y-1 group"
            >
              <div className="cht-w-12 cht-h-12 cht-flex cht-items-center cht-justify-center cht-mb-3 cht-transition-transform group-hover:cht-scale-110">
                <img
                  src={item.get_logo_url}
                  className="cht-max-w-[42px] cht-max-h-[42px] cht-object-contain"
                  alt={`Logo of ${item.name_of_technology}`}
                  loading="lazy"
                />
              </div>

              <p className="!cht-font-body cht-text-xs sm:cht-text-sm !cht-font-bold cht-text-slate-800 group-hover:cht-text-[#3e57da] cht-transition-colors cht-mb-0">
                {item.name_of_technology}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Technologies;

